"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = require("@jsluna/grid");

var _button = require("@jsluna/button");

var _constants = require("../../utils/constants");

var _uuid = require("uuid");

var _EditChecklistItem = _interopRequireDefault(require("./EditChecklistItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var EditChecklist = function EditChecklist(_ref) {
  var newItemTitle = _ref.newItemTitle,
      newItemDescription = _ref.newItemDescription,
      onSave = _ref.onSave,
      maxItems = _ref.maxItems,
      checklistItemsInitState = _ref.checklistItemsInitState;

  var _useState = (0, _react.useState)(function () {
    return checklistItemsInitState.map(function (item) {
      return Object.assign({}, item, {
        error: null
      });
    });
  }),
      checklistItems = _useState[0],
      setChecklistItems = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isEditing = _useState2[0],
      setIsEditing = _useState2[1];

  var handleAddItem = function handleAddItem() {
    setIsEditing(true);

    if (checklistItems.length === maxItems) {
      setChecklistItems(function (prevItems) {
        return prevItems.map(function (item, index) {
          return index === checklistItems.length - 1 ? Object.assign({}, item, {
            error: 'You can add only up to 20 items, currently.'
          }) : item;
        });
      });
      return;
    }

    setChecklistItems(function (prevItems) {
      return [].concat(prevItems.map(function (item) {
        return Object.assign({}, item, {
          error: null
        });
      }), [{
        id: (0, _uuid.v1)(),
        text: '',
        error: null
      }]);
    });
  };

  var handleRemoveItem = function handleRemoveItem(id) {
    setIsEditing(true);
    setChecklistItems(function (prevItems) {
      return prevItems.filter(function (item) {
        return item.id !== id;
      });
    });
    setChecklistItems(function (prevItems) {
      return prevItems.map(function (item) {
        return Object.assign({}, item, {
          error: null
        });
      });
    });
  };

  var handleTextChange = function handleTextChange(id, newText) {
    setIsEditing(true);
    setChecklistItems(function (prevItems) {
      return prevItems.map(function (item) {
        return item.id === id ? Object.assign({}, item, {
          text: newText,
          error: null
        }) : Object.assign({}, item, {
          error: null
        });
      });
    });
  };

  var handleSave = function handleSave() {
    if (checklistItems.some(function (item) {
      return item.text === null || item.text.trim() === '';
    })) {
      setChecklistItems(function (prevItems) {
        return prevItems.map(function (item) {
          return item.text === null || item.text.trim() === '' ? Object.assign({}, item, {
            error: "Please finish adding an item, or it it's not needed, remove it using the delete button"
          }) : item;
        });
      });
      return;
    }

    onSave(checklistItems.map(function (item, index) {
      return Object.assign({}, item, {
        position: index + 1
      });
    }));
    setIsEditing(false);
  };

  var handleMoveItem = function handleMoveItem(id, direction) {
    setIsEditing(true);
    var index = checklistItems.findIndex(function (item) {
      return item.id === id;
    });
    var newIndex = direction === _constants.MOVE_DIRECTION.UP ? index - 1 : index + 1;

    if (newIndex >= 0 && newIndex < checklistItems.length) {
      var updatedItems = [].concat(checklistItems);
      var movedItem = updatedItems.splice(index, 1)[0];
      updatedItems.splice(newIndex, 0, movedItem);
      setChecklistItems(updatedItems);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, checklistItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_EditChecklistItem.default, {
      key: item.id,
      item: item,
      newItemTitle: newItemTitle,
      newItemDescription: newItemDescription,
      index: index,
      checklistItems: checklistItems,
      handleMoveItem: handleMoveItem,
      handleRemoveItem: handleRemoveItem,
      handleTextChange: handleTextChange
    });
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/4'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: handleAddItem,
    className: "ln-c-button--full ln-u-bg-color-white ln-u-margin-bottom*2 ln-u-padding-sides*3 ln-u-margin-right*2"
  }, "Add item")), isEditing && /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/4'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    onClick: handleSave,
    className: "ln-c-button--full ln-u-bg-color-white ln-u-margin-bottom*2 ln-u-padding-sides*2"
  }, "Save checklist"))));
};

EditChecklist.propTypes = {
  maxItems: _propTypes.default.number,
  onSave: _propTypes.default.func.isRequired,
  newItemTitle: _propTypes.default.string,
  newItemDescription: _propTypes.default.string,
  checklistItemsInitState: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  }))
};
EditChecklist.defaultProps = {
  maxItems: 20,
  title: 'Checklist',
  newItemTitle: null,
  newItemDescription: null,
  checklistItemsInitState: []
};
var _default = EditChecklist;
exports.default = _default;